import React from 'react';
import {ProductionMaif} from "../components/ProductionMaif";
import 'leaflet/dist/leaflet.css';
import '../../scss/carte-des-investissements.scss';

export function CarteDesInvestissements(props) {
    return (
        <ProductionMaif {...props} />
    )
}